/**
 * WILD BUCK NUTRITION - INTERACTION FOUNDATION MODULE
 */
document.addEventListener('DOMContentLoaded', () => {
  initPreloader();
  initScrollReveals();
  initWishlistEngine();
  initAuthenticityChecker();
});

/* Wild Buck Preloader Dismissal Handler */
function initPreloader() {
  const preloader = document.getElementById('wb-preloader');
  if (!preloader) return;

  function dismiss() {
    preloader.classList.add('wb-preloader-hidden');
    setTimeout(() => {
      preloader.remove();
    }, 600);
  }

  if (document.readyState === 'complete') {
    setTimeout(dismiss, 400);
  } else {
    window.addEventListener('load', () => {
      setTimeout(dismiss, 400);
    });
    // Fallback safety timeout if resources lag
    setTimeout(dismiss, 2800);
  }
}

/* IntersectionObserver Scroll Reveal Handler */
function initScrollReveals() {
  const revealElements = document.querySelectorAll('.wb-reveal');
  if (!revealElements.length) return;

  if (!('IntersectionObserver' in window)) {
    revealElements.forEach(el => el.classList.add('active'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('active');
      }
    });
  }, { threshold: 0.12 });

  revealElements.forEach(el => observer.observe(el));
}

/* LocalStorage Wishlist Handler */
function initWishlistEngine() {
  let wishlist = JSON.parse(localStorage.getItem('wb_wishlist') || '[]');

  function updateWishlistButtons() {
    document.querySelectorAll('.wb-wishlist-btn').forEach(btn => {
      const productId = btn.getAttribute('data-product-id');
      if (wishlist.includes(productId)) {
        btn.classList.add('is-active');
        btn.setAttribute('aria-label', 'Remove from Wishlist');
      } else {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-label', 'Add to Wishlist');
      }
    });
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.wb-wishlist-btn');
    if (!btn) return;

    e.preventDefault();
    const id = btn.getAttribute('data-product-id');
    if (!id) return;

    if (wishlist.includes(id)) {
      wishlist = wishlist.filter(item => item !== id);
    } else {
      wishlist.push(id);
    }

    localStorage.setItem('wb_wishlist', JSON.stringify(wishlist));
    updateWishlistButtons();
  });

  updateWishlistButtons();
}

/* Product Authenticity Scratch Code Checker */
function initAuthenticityChecker() {
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('.wb-auth-form');
    if (!form) return;

    e.preventDefault();
    const input = form.querySelector('.wb-auth-input');
    const resultContainer = form.querySelector('.wb-auth-result');
    if (!input || !resultContainer) return;

    const code = input.value.trim().toUpperCase();
    resultContainer.style.display = 'block';

    if (code.startsWith('WB') && code.length >= 8) {
      resultContainer.innerHTML = `
        <div style="margin-top: 16px; padding: 14px 18px; background: rgba(0, 176, 80, 0.1); border: 1px solid #00B050; border-radius: 10px; color: #00B050; font-weight: 600; font-size: 0.9rem;">
          ✓ Authentic Product Verified. Batch #${code} passed 100% HPLC lab purity testing.
        </div>
      `;
    } else if (code.includes('DUP')) {
      resultContainer.innerHTML = `
        <div style="margin-top: 16px; padding: 14px 18px; background: rgba(255, 184, 0, 0.1); border: 1px solid #FFB800; border-radius: 10px; color: #D49B00; font-weight: 600; font-size: 0.9rem;">
          ⚠️ This product has already been verified.
        </div>
      `;
    } else {
      resultContainer.innerHTML = `
        <div style="margin-top: 16px; padding: 14px 18px; background: rgba(255, 42, 42, 0.1); border: 1px solid #FF2A2A; border-radius: 10px; color: #FF2A2A; font-weight: 600; font-size: 0.9rem;">
          ✕ This code could not be verified. Please check your scratch label.
        </div>
      `;
    }
  });
}
